<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">
                Обзор
            </div>
        </div>
    </div>
    <div class="summary-list">
        <div class="summary">
            <div class="summary__title">
                Сводка по устройствам
            </div>
            <div class="summary__content">
                <div class="sum-devices">
                    <div class="sum-devices__choice">
                        <v-select
                            v-model="deviceType"
                            :items="deviceTypes"
                            item-title="name"
                            variant="outlined"
                            color="primary"
                            density="compact"
                            return-object
                            clearable
                            @update:modelValue="setDevicesChart"
                            @update:menu="$removeFocus"
                            @click:clear="$removeFocus"
                            @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </div>
                    <div class="sum-list">
                        <div class="sum-item">
                            <div v-for="stat in deviceStats" class="sum-item__title">
                                {{ stat.status_name }}
                                <div v-if="stat.id == 1" class="sum-item__info color-green">
                                    {{ stat.quantity }}
                                </div>
                                <div v-else-if="stat.id == 2" class="sum-item__info color-orange">
                                    {{ stat.quantity }}
                                </div>
                                <div v-else-if="stat.id == 3" class="sum-item__info color-red">
                                    {{ stat.quantity }}
                                </div>
                            </div>
                        </div>
                        <div class="sum-item">
                            <div class="center-caption">
                                Всего
                                <p class="center-caption__bold-text">{{ this.deviceStats.reduce((total, stat) => total + stat.quantity, 0) }}</p>
                            </div>
                            <Doughnut class="summary__chart" id="DashboardDoughnutChart" :data="devicesChartData" :options="devicesChartOptions" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="summary">
            <div class="summary__title">
                Сводка по плейлистам
            </div>
            <div class="summary__content-playlist">
                <div class="sum-playlists">
                    <div class="sum-list__playlist">
                        <div class="sum-item">
                            <div v-for="stat in playlistStats" class="sum-item__title-playlist">
                                {{ stat.name }}
                                <div class="sum-item__info">
                                    {{ stat.quantity }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="summary">
            <div class="summary__title">
                Cтатистика использования хранилища
            </div>
            <div class="summary__content">
                <div style="flex-direction: column;" class="sum-list">
                    <div class="sum-item">
                        <div class="center-caption">
                            Всего
                            <p class="center-caption__bold-text">{{ this.deviceStats.reduce((total, stat) => total + stat.quantity, 0) }}</p>
                        </div>
                        <Doughnut class="summary__chart" id="DashboardDoughnutChart" :data="storageChartData" :options="storageChartOptions" />
                    </div>
                    <div style="align-items: flex-start;" class="sum-item">
                        <div v-for="stat in storageStats" class="sum-item__storage-title">
                            <div :style="{backgroundColor: stat.color}" style="width: 15px; height: 15px;"></div>{{ stat.name }} - {{ stat.value }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="summary">
        <div class="summary__line-chart-title">
            <div class="summary__line-chart-ctrls-left">
                <span>Обновление</span>
                <div style="padding: 0px 10px" class="tabs">
                    <div class="tabs__ctrls">
                        <button class="reset-btn tabs__ctrl local" v-on:click.prevent="source = 'link'"
                            :class="{ 'is-selected': source === 'link' }" type="button">
                            Версии ПО
                        </button>
                        <button class="reset-btn tabs__ctrl cloud" v-on:click.prevent="source = 'cloud'"
                            :class="{ 'is-selected': source === 'cloud' }" type="button">
                            Контент
                        </button>
                    </div>
                </div>
            </div>
            <div class="summary__line-chart-ctrls-right">
                    <v-select
                        v-model="deviceType"
                        :items="deviceTypes"
                        item-title="name"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        return-object
                        clearable
                        @update:modelValue="setDevicesChart"
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>

                    <div class="summary__line-chart-legend">
                        <div :style="{backgroundColor: version7_1.color}" style="width: 15px; height: 15px; border-radius: 50%;"></div>
                        Версия 7.1
                    </div>
                    <div class="summary__line-chart-legend">
                        <div :style="{backgroundColor: version7_2.color}" style="width: 15px; height: 15px; border-radius: 50%;"></div>
                        Версия 7.2
                    </div>

            </div>
        </div>
        <div class="summary__content">
            <div class="sum-item">
                <Line class="summary__line-chart" :data="updateChartData" :options="updateChartOptions" />
            </div>
        </div>
    </div>

</template>

<script>
import { Chart, registerables } from 'chart.js'
import { Doughnut, Line } from 'vue-chartjs'

Chart.register(...registerables);

export default {
    name: "DashboardComponent",
    components: { Doughnut, Line },

    data () {
        return {
            deviceType: '',
            deviceTypes: [
                {id: 1, name: 'Все', online: 1400, offline: 1000, error: 650},
                {id: 2, name: 'Рекламный ТВ', icon: '/images/tvIcon.svg', online: 300, offline: 200, error: 100},
                {id: 3, name: 'Инфокиоск самообслуживания', icon: '/images/kioskIcon.svg', online: 200, offline: 100, error: 50},
                {id: 4, name: 'Инфокиоск электронной очереди', icon: '/images/queueIcon.svg', online: 400, offline: 300, error: 200},
                {id: 5, name: 'ТВ электронной очереди', icon: '/images/tvekIcon.svg', online: 500, offline: 400, error: 300},
            ],
            deviceStats: [
                {id: 1, status_name: 'Онлайн', status_color: '#81E17E', quantity: null},
                {id: 2, status_name: 'Офлайн', status_color: '#FFC356', quantity: null},
                {id: 3, status_name: 'Ошибка', status_color: '#EF5E70', quantity: null}
            ],
            playlistStats: [
                {id: 1, name: 'Всего плейлистов', quantity: 14},
                {id: 2, name: 'Устройств без плейлистов', quantity: 2},
                {id: 3, name: 'Плейлистов на сегодня', quantity: 1}
            ],
            storageStats: [
                {id: 1, name: 'Свободно', color: '#D1D1D1', value: 14},
                {id: 2, name: 'Контент', color: '#0678F4', value: 2},
                {id: 3, name: 'Медиафайлы устройств и групп', color: '#F970B2', value: 1}
            ],
            version7_1: [
                {id: 1, date: '01.10.24', color: '#F970B2', value: 14},
                {id: 2, date: '01.10.24', color: '#F970B2', value: 13},
                {id: 3, date: '01.10.24', color: '#F970B2', value: 15},
                {id: 4, date: '01.10.24', color: '#F970B2', value: 12},
                {id: 5, date: '01.10.24', color: '#F970B2', value: 9},
                {id: 6, date: '01.10.24', color: '#F970B2', value: 16},
                {id: 7, date: '01.10.24', color: '#F970B2', value: 19},
                {id: 8, date: '01.10.24', color: '#F970B2', value: 17},
                {id: 9, date: '01.10.24', color: '#F970B2', value: 15},
                {id: 10, date: '01.10.24', color: '#F970B2', value: 11},
                {id: 11, date: '01.10.24', color: '#F970B2', value: 7},
                {id: 12, date: '01.10.24', color: '#F970B2', value: 10},
                {id: 13, date: '01.10.24', color: '#F970B2', value: 12},
                {id: 14, date: '01.10.24', color: '#F970B2', value: 15},
                {id: 15, date: '01.10.24', color: '#F970B2', value: 19},
                {id: 16, date: '01.10.24', color: '#F970B2', value: 24},
            ],
            version7_2: [
                {id: 1, date: '01.10.24', color: '#0678F4', value: 11},
                {id: 2, date: '01.10.24', color: '#0678F4', value: 9},
                {id: 3, date: '01.10.24', color: '#0678F4', value: 5},
                {id: 4, date: '01.10.24', color: '#0678F4', value: 2},
                {id: 5, date: '01.10.24', color: '#0678F4', value: 1},
                {id: 6, date: '01.10.24', color: '#0678F4', value: 3},
                {id: 7, date: '01.10.24', color: '#0678F4', value: 7},
                {id: 8, date: '01.10.24', color: '#0678F4', value: 13},
                {id: 9, date: '01.10.24', color: '#0678F4', value: 18},
                {id: 10, date: '01.10.24', color: '#0678F4', value: 26},
                {id: 11, date: '01.10.24', color: '#0678F4', value: 22},
                {id: 12, date: '01.10.24', color: '#0678F4', value: 25},
                {id: 13, date: '01.10.24', color: '#0678F4', value: 24},
                {id: 14, date: '01.10.24', color: '#0678F4', value: 20},
                {id: 15, date: '01.10.24', color: '#0678F4', value: 17},
                {id: 16, date: '01.10.24', color: '#0678F4', value: 10},
            ],
            devicesChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                    },
                ],
            },
            devicesChartOptions: {
                responsive: true,
                cutout: '70%',
                plugins: {
                    legend: {
                        display: false
                    },
                },
            },

            storageChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                    },
                ],
            },
            storageChartOptions: {
                responsive: true,
                cutout: '70%',
                plugins: {
                    legend: {
                        display: false
                    },
                },
            },

            updateChartData: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        borderColor: '#F970B2'
                    },
                    {
                        data: [],
                        backgroundColor: [],
                        borderColor: '#0678F4'
                    }
                ],
            },
            updateChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                },
            },
        }
    },
    methods: {
        setChartData: function () {
            let devicesChartDataCopy = JSON.parse(JSON.stringify(this.devicesChartData));
            let storageChartDataCopy = JSON.parse(JSON.stringify(this.storageChartData));
            let updateChartDataCopy = JSON.parse(JSON.stringify(this.updateChartData));

            this.deviceStats.forEach(stat => {
                devicesChartDataCopy.labels.push(stat.status_name);
                devicesChartDataCopy.datasets[0].backgroundColor.push(stat.status_color);
            });

            this.storageStats.forEach(stat => {
                storageChartDataCopy.labels.push(stat.name);
                storageChartDataCopy.datasets[0].data.push(stat.value);
                storageChartDataCopy.datasets[0].backgroundColor.push(stat.color);
            });

            this.version7_1.forEach(stat => {
                updateChartDataCopy.labels.push(stat.date);
                updateChartDataCopy.datasets[0].data.push(stat.value);
                updateChartDataCopy.datasets[0].backgroundColor.push(stat.color);
            });

            this.version7_2.forEach(stat => {
                updateChartDataCopy.datasets[1].data.push(stat.value);
                updateChartDataCopy.datasets[1].backgroundColor.push(stat.color);
            });

            this.devicesChartData = devicesChartDataCopy;
            this.storageChartData = storageChartDataCopy;
            this.updateChartData = updateChartDataCopy;
        },
        getTotalQuantity: function () {
            return this.deviceStats.reduce((total, stat) => total + stat.quantity, 0);
        },
        setDevicesChart: function (deviceType) {
            let updatedDevicesChartData = JSON.parse(JSON.stringify(this.devicesChartData));

            updatedDevicesChartData.datasets[0].data = [deviceType.online, deviceType.offline, deviceType.error];
            this.devicesChartData = updatedDevicesChartData;

            this.deviceStats.forEach(stat => {
                if (stat.id == 1) {
                    stat.quantity = deviceType.online
                }
                else if (stat.id == 2) {
                    stat.quantity = deviceType.offline
                }
                else if (stat.id == 3) {
                    stat.quantity = deviceType.error
                }
            })
        },
    },
    mounted () {
        this.deviceType = this.deviceTypes[0];
        this.setChartData();
        this.setDevicesChart(this.deviceType);
    }
}
</script>

<style scoped>

</style>
